export class SidebarMenuItem
{
	icon
	route
	children = []
	hidden

	constructor(icon, label, route, children = null, hidden = false, expanded = false, actionType = null, permission = null, unreadCount = 0)
	{
		this.icon = icon
		this.label = label
		this.route = route
		this.children = children
		this.hidden = hidden
		this.expanded = expanded
		this.actionType = actionType
		this.permission = permission
		this.unreadCount = unreadCount
	}
}